import React, { Component } from "react";
import { StaticQuery, Link, graphql } from "gatsby";

class Offcanvas extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            mainMenu: wordpressWpApiMenusMenusItems(slug: { eq: "main-menu" }) {
              name
              items {
                title
                url
              }
            }
            socialMenu: wordpressWpApiMenusMenusItems(slug: { eq: "social" }) {
              name
              items {
                title
                url
              }
            }
          }
        `}
        render={data => {
          const menu = data.mainMenu;
          menu.items.map(item => {
            let parts = item.url.split("/");
            parts = parts.slice(3);
            item.slug = parts.join("/");
            return item.slug;
          });
          return (
            <aside
              className={`offcanvas card ${
                this.props.isVisible ? "is-open" : ""
              }`}
            >
              <div className="card-content">
                <div className="container">
                  <div className="has-text-right">
                    <span
                      className="offcanvas-close"
                      onClick={() => this.props.toggleOffcanvas()}
                    >
                      close
                    </span>
                  </div>
                  <ul className="offcanvas-menu">
                    {menu.items.map(item => (
                      <li key={item.title}>
                        <Link
                          to={`/${item.slug}`}
                          onClick={() => this.props.toggleOffcanvas()}
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <ul className="offcanvas-social">
                    {data.socialMenu.items.map(item => (
                      <li key={item.title}>
                        <a href={item.url}>{item.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </aside>
          );
        }}
      />
    );
  }
}

export default Offcanvas;
